import React = require("react");
import "./filters.scss";
import {defaultTheme} from "@vebox/etui-themes";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../index";

interface FilterProps {
    title: string;
    onChange: (text: string) => any;
}

interface FilterState {
    value: string;
}

export class InputFilter extends React.Component<FilterProps, FilterState> {

    constructor(props: FilterProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {value: ""};
    }

    public reset() {
        this.setState({value: ""});
        this.props.onChange(null);
    }

    public render() {
        let title = <p className="filterTitleMaterial">{this.props.title}</p>;
        if (this.state.value != null && this.state.value.trim() !== "") {
            title = (
                <p className="filterTitleMaterial filtersGroupTitleEnlight">
                    {this.props.title}
                </p>
            );
        }
        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                <div>
                    {title}
                    <input
                        type={"text"}
                        className="filterContentTextInput"
                        onChange={this.onChange}
                        value={this.state.value}
                    />
                </div>
            </ThemeProvider>
        );
    }

    private onChange(e: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({value: e.target.value});
        this.props.onChange(e.target.value);
    }
}
